<template>
  <div class="row">
    <div class="col-md-3 col-12 mb-4" v-for="item in propsRows" :key="item.id">
      <div class="card h-100">
        <div class="card-header">
          <i :class="item.departmentIcon == null ? 'fad fa-users-class' : item.departmentIcon"></i> &nbsp; &nbsp;{{ item.departmentName }}
          <b-dropdown size="md" variant="link" class="d-inline float-left btn-more text-center" toggle-class="text-decoration-none " no-caret>
            <template #button-content>
              <h4><i class="fad fa-ellipsis-v"></i></h4>
            </template>
            <b-dropdown-item @click="changeState(3, item)" class="text-center">اضافه کردن کاربر</b-dropdown-item>
            <b-dropdown-item @click="SetWorkFlow(item)" class="text-center">تنظیمات مســیر کاری</b-dropdown-item>
            <b-dropdown-item @click="changeState(2, item)" class="text-center"> ویرایش</b-dropdown-item>
            <b-dropdown-item @click="removeDep(item)" class="text-center">حذف </b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="card-body">
          <span class="badge border m-1 p-2" v-for="user in item.users" :key="user.tblUserId">
            {{ user.namFam }} &nbsp;&nbsp;
            <i @click="removeUser(item.id, user.tblUserId, user.namFam)" class="fas fa-times hover-danger"></i>
          </span>
        </div>
      </div>
    </div>

    <modal v-if="$store.state.Modal" :InheritanceTheme="true" :IsFooter="false" :Size="ModalSize">
      <template v-slot:header>
        <h4 class="text-warning d-inline">{{ DataSelected.departmentName }}</h4>
        <hr />
      </template>
      <template v-slot:body>
        <div>
          <div class="container px-5">
            <div class="row px-4" v-for="(item, key) in ListFormAutomatioan" :key="key">
              <div class="col-md-1"></div>
              <div class="col-md-4 text-right"><i class="fad fa-bezier-curve ml-3"></i>{{ item.name }}</div>
              <div class="col-md-4 text-center">
                <SearchableCombo
                  :ActiveDelete="true"
                  @deleteSelected="DeleteValCombo"
                  :defaultvalue="DataAxios[key].tblWorkFlowId"
                  :ClassProps="'text-center'"
                  :edit="false"
                  :grp="null"
                  :code="null"
                  @ResultCombo="GetListWorkflowForCombo"
                  :rownumintable="2"
                  :action="'Workflow/GetListWorkflowForCombo'"
                  :method="'POST'"
                  :idinput="'WFId'"
                  :keyItem="'WFId' + item.id"
                  :disabled="false"
                >
                </SearchableCombo>
              </div>
              <div class="col-md-2 text-center">
                <i class="fad fa-eye mt-3 Pointer hover-info" style="font-size: 18px" title="پیش نمایش مسیر کاری" @click="GotoWorkFlow(item, DataAxios)"></i>
                <!-- <i class="fad fa-check mt-3 Pointer hover-success mr-4" style="font-size:18px;" title=" ثبت مسیر انتخابی"></i> -->
              </div>
              <div class="col-md-1"></div>
            </div>
            <div class="row text-left">
              <div class="col-md-3">
                <button type="button" class="btn btn-success" @click="SetAutomationDepartementWorkFlow"><i class="fad fa-plus ml-3 mt-1"></i> ثبت اطلاعات</button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import Modal from '@/pages/Modal/Modal.vue'
export default {
  components: { SearchableCombo, Modal },
  props: ['propsRows', 'List', 'tbldepartemnet'],
  data() {
    return {
      propsRows: [],
      ModalSize: 'Md',
      DataSelected: {},
      ListFormAutomatioan: [],
      DataAxios: [],
      InformationRow: [],
    }
  },
  methods: {
    changeState(state, item) {
      this.$emit('ChangeState', { state: state, item: item })
    },
    removeDep(item) {
      this.$RemoveAlert('اطمینان دارید از حذف ' + item.departmentName + '؟').then((res) => {
        if (res) {
          this.$PostData_new('delete', 'AutomationDepartment/' + item.id)
            .then((res) => {
              if (res.isSuccess) {
                this.$mySweetDefaultTost('عملیات موفق', res.message, 'success', 2000)
                this.$emit('Result', res.isSuccess)
              } else {
                this.$mySweetDefaultTost('عملیات ناموفق', res.message, 'error', 2000)
              }
            })
            .catch((err) => {
              this.$mySweetDefaultTost('عملیات ناموفق', 'خطا سمت سرور', 'error', 2000)
              console.error(err)
            })
        }
      })
    },
    removeUser(depId, userId, namFam) {
      this.$RemoveAlert('اطمینان دارید از حذف ' + namFam + '؟').then((res) => {
        if (res) {
          this.$PostData_new('delete', 'AutomationDepartment/DeleteUser', { AutomationeDepartmenId: depId, UserId: userId })
            .then((res) => {
              if (res.isSuccess) {
                this.$mySweetDefaultTost('عملیات موفق', res.message, 'success', 2000)
                this.$emit('Result', res.isSuccess)
              } else {
                this.$mySweetDefaultTost('عملیات ناموفق', res.message, 'error', 2000)
              }
            })
            .catch((err) => {
              this.$mySweetDefaultTost('عملیات ناموفق', 'خطا سمت سرور', 'error', 2000)
              console.error(err)
            })
        }
      })
    },
    SetWorkFlow(item) {
      this.GetListFormAutomation()
      this.DataSelected = item
    },
    GetListFormAutomation(props) {
      let DataAxios_GetData = {
        ArryfildValue: {},
        Method: 'Get',
        Action: 'Workflow/GetListFormAutomation',
        Token: this.$session.get('Token'),
      }
      this.$PostData(DataAxios_GetData).then((data) => {
        this.ListFormAutomatioan = data
        var formData = new FormData()
        formData.append('tblDepartementId', this.DataSelected.id)
        var DataAxios = { Method: 'Post', Action: 'WorkFlowFormDepartment/Get', ArryfildValue: null }
        DataAxios.ArryfildValue = formData
        this.$PostFormData(DataAxios).then((res) => {
          this.DataAxios=[]
            this.InformationRow = res.data
            data.forEach((element) => {
              let WF = res.status == 'Ok'?this.InformationRow.find((x) => x.tblFormAutomationId == element.id):null
              let obj = {
                tblFormAutomationId: element.id,
                tblWorkFlowId: WF ? WF.tblWorkFlowId : null,
                tblWorkFlowName: '',
              }
              if (props) {
                this.DataAxios=props
                this.List=[]
              } else {
                this.DataAxios.push(obj)
              }
            })
            this.$store.state.Modal = true
        })
      })
    },
    GetListWorkflowForCombo(val) {
      if (val.id != null && val.id > 0) {
        let FA = val.key.split('WFId')[1]
        let Find = this.DataAxios.find((x) => x.tblFormAutomationId == FA)
        Find.tblWorkFlowId = val.id
        Find.tblWorkFlowName = val.name
      }
    },
    DeleteValCombo(val) {
      let FA = val.key.split('WFId')[1]
      let Find = this.DataAxios.find((x) => x.tblFormAutomationId == FA)
      Find.tblWorkFlowId = null
    },
    GotoWorkFlow(item, List) {
      let Find = this.DataAxios.find((x) => x.tblFormAutomationId == item.id)
      if (Find.tblWorkFlowId != null) {
        this.$router.push({ name: 'Workflow', params: { Id: Find.tblWorkFlowId, Name: Find.tblWorkFlowName, List: List, tbldepartemnet: this.DataSelected } })
      } else {
        this.$toasted.error('مسیر کاری انتخاب نشده ، لطفا برای پیش نمایش ابتدا یک مسیر کاری انتخاب نمایید', { durations: 3000 })
      }
    },
    SetAutomationDepartementWorkFlow() {
      let Model = {
        tbldepartemntId: this.DataSelected.id,
        ListAutomationDepartementWorkFlow: this.DataAxios,
      }
      let DataAxios_SetData = {
        ArryfildValue: {},
        Method: 'post',
        Action: 'WorkFlowFormDepartment',
        Token: this.$session.get('Token'),
      }

      DataAxios_SetData.ArryfildValue = Model
      this.$PostData(DataAxios_SetData).then((data) => {
        if (data.status == 'Ok') {
          this.$toasted.success('ذخیره اطلاعات با موفقیت انجام شد', { duration: 2000 })
          this.$store.state.Modal = false
          // this.GetAutomationDepartementWorkFlow()
          this.GetListFormAutomation()
        }
      })
    },
    GetAutomationDepartementWorkFlow() {
      var formData = new FormData()
      formData.append('tblDepartementId', this.DataSelected.id)
      var DataAxios = { Method: 'Post', Action: 'WorkFlowFormDepartment/Get', ArryfildValue: null }
      DataAxios.ArryfildValue = formData
      this.$PostFormData(DataAxios).then((data) => {
        if (data.status == 'Ok') {
          this.InformationRow = data.data
          // var arr = []
          // data.data.forEach((el) => {
          //   let model = {
          //     tblFormAutomationId: el.tblFormAutomationId,
          //     tblWorkFlowId: el.tblWorkFlowId,
          //     tblWorkFlowName: '',
          //   }
          //   arr.push(model)
          // })
          // if (data.data.length == this.ListFormAutomatioan.length) {
          //   this.DataAxios = arr
          //   console.warn("IF");
          // } else {
          //   console.warn("ELSE");
          //   this.GetListFormAutomation()
          // }
        }
      })
    },
  },
  mounted() {
    if (this.List) {
      this.DataSelected = this.tbldepartemnet
      this.GetListFormAutomation(this.List)
    }
  },
}
</script>

<style scoped>
.card {
  background: var(--sidebar-bg-color);
  border: solid 1px var(--logo-color);
}

.card-header {
  color: var(--logo-color);
  border: solid 1px var(--logo-color);
}

.hover-danger:hover {
  color: #a11414 !important;
  cursor: pointer;
}

u.text-info {
  font-size: 15px;
}

.badge {
  font-weight: normal !important;
  background: var(--sidebar-bg-color);
}

.badge:hover {
  cursor: pointer;
  font-size: medium;
  font-weight: bold;
  transform: 1s !important;
}
</style>
